var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.03.034h9.96v9.064H.03z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M14.652 16.49l-3.81 3.81h-.056v-3.866h3.866v.056zm.202-7.848a1.31 1.31 0 0 1-.202-.017V15.6h-3.866a.836.836 0 0 0-.834.833V20.3H2.083a.422.422 0 0 1-.416-.416V3.248c0-.225.19-.416.416-.416h7.424a7.987 7.987 0 0 1 2.612-1.667H2.083A2.09 2.09 0 0 0 0 3.248v16.635a2.09 2.09 0 0 0 2.083 2.083h8.123l.001-.002c.096-.002.21-.061.334-.185l5.589-5.589c.123-.124.183-.238.185-.333l.003-.004V7.72l-.372.411c-.3.33-.687.512-1.092.512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M4.37 10.667v.833c0 .115.093.209.208.209h7.11a.21.21 0 0 0 .208-.209v-.833a.209.209 0 0 0-.208-.208h-7.11a.209.209 0 0 0-.208.208M4.37 13.667v.833c0 .115.093.209.208.209h7.11a.21.21 0 0 0 .208-.209v-.833a.209.209 0 0 0-.208-.208h-7.11a.209.209 0 0 0-.208.208M4.37 5.459v.833c0 .114.093.208.208.208h2.745a9.239 9.239 0 0 1 .472-1.25H4.578a.209.209 0 0 0-.208.209M11.896 8.896v-.833a.209.209 0 0 0-.208-.208h-.406c-.548.404-1.04.852-1.43 1.25h1.836a.21.21 0 0 0 .208-.209M4.578 9.105h2.34c0-.14.006-.605.103-1.25H4.578a.209.209 0 0 0-.208.208v.833c0 .115.093.209.208.209"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.139 .015)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M9.873 3.357L6.884.133c-.156-.168-.283-.118-.283.112V1.78a3.792 3.792 0 0 0-.48.058C-.137 2.97.03 9.099.03 9.099s2.93-3.732 6.09-3.732c.175 0 .334-.007.481-.019v1.82c0 .228.126.277.28.107l2.995-3.304a.464.464 0 0 0-.003-.614",
    mask: "url(#b)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.2b879e57afb925bdcc7bc5c33e8e3696.svg";
export { ForwardRef as ReactComponent };